<template>
  
    <div class="edit-modal">
      
        <div class="container">
          <!-- <div class="title">Selected Publishers</div>
          <a-tag
            v-for="tag in editData"
            :key="tag.brandId"
            color="blue"
            class="tag-item"
          >
            {{ tag.creatorName }} 
          </a-tag> -->
          <div class="title" style="padding-bottom: 8px;">{{ $t('seller.brandsPage.selectedPublishers') }}</div>
        <div class="tags-container">
          <div v-for="tag in editData" :key="tag.brandId" class="tag-item">
            <LogoImage :maxWidth="'95%'" :logoUrl="tag?.publicImage" :brandName="tag?.creatorName" :width="20"
            :height="20" :lineHeight="6" :fontSize="5" :borderRadius="4" />
            <span>{{ tag.creatorName }} </span>
          </div>
        </div>
        </div>
    
     <!-- 中间 -->
      <div class="commission-section" >
        <div class="title" >{{ $t('seller.brandsPage.commissionRate') }}</div>
      
        <div class="content">
          <div class="commission">
            <div class="commission-input">
              <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
              <artmisads-input-number 
              :placeholder="$t('seller.common.pleaseEnter')"
              :min="0" :max="100" suffix="%" :step="0.5" size="large" @blur="commissionBlur"
                v-model:value="commission" @change="handleChangeCommission($event)" />
             
            </div>
            <span>+</span>
            <div class="fees" ref="fees">
              <span>{{ $t('seller.brandsPage.artemisAdsFees') }}
                <!-- <a-tooltip :getPopupContainer="() => $refs.fees">
                  <template #title>Publisher Commission x 20%, Max 3.5%</template>
                  <Icon name="wenhao-tianchong" class="question-icon" />
                </a-tooltip> -->
              </span>
              <artmisads-button disabled>
                <!-- {{ fees.toFixed(1) }}% -->
                  3.0%
              </artmisads-button>
            </div>
            <span>=</span>
            <div class="total">
              <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
              <artmisads-button disabled>
                <span>{{
                  commission
                    ? parseFloat(3 + Number(commission)).toFixed(1)
                    : 3.0
                }}</span>
                <span>%</span>
              </artmisads-button>
            </div>
          </div>

        </div>
      </div>
      <!-- Collaboration Period -->
      <div class="collaboration-section" ref="setCommissionRef">
        <div class="section-title">{{ $t('seller.brandsPage.collaborationPeriod') }}</div>
        <div class="date-row">
          <div class="date-group">
            <div class="date-label">{{ $t('seller.brandsPage.startDate') }}</div>
            <a-date-picker  v-model:value="formData.startDate" :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD"
              class="date-picker" :disabled-date="disabledStartDate" 
              @change="handleStartDateChange"
              :getPopupContainer="() => $refs.setCommissionRef"
              />
          </div>
          <div class="date-group">
            <div class="date-label">{{ $t('seller.brandsPage.endDate') }}</div>
            <a-date-picker
             :disabled="isAutoRenew"
             :allowClear="true" picker="month" close-on-select v-model:value="formData.endDate" :placeholder="$t('seller.common.selectMonth')" format="YYYY-MM-DD"
              class="date-picker" :disabled-date="disabledEndDate" :allow-clear="false" 
              @change="handleEndDateChange"  :getPopupContainer="() => $refs.setCommissionRef"/>
          </div>
         
        </div>
      </div>
             <div class="auto-renew-section">
         <a-radio 
           v-model:checked="isAutoRenew" 
           @change="handleAutoRenewChange"
           @click="handleRadioClick">{{ $t('seller.brandsPage.continuous') }}</a-radio>
       </div>
      <!-- Footer Buttons -->
      <div class="modal-footer">
       
        <artmisads-button :isSquare="true" type="primary" @click="handleSave" :loading="saving">
          {{ $t('seller.brandsPage.save') }}
        </artmisads-button>
      </div>
      <PartneredDataModel ref="partneredDataModelRef" @confirm="handleConfirm" :saving="saving"/>
    </div>
 
</template>

<script setup>
import i18n from '~/i18n'

import { ref, reactive, watch, computed } from 'vue'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { publishersApi } from '@/server'
import PartneredDataModel from './partneredDataModel.vue'
import LogoImage from '@/components/LogoImage.vue'
 
const emit = defineEmits(['refresh'])
const currentTags = ref([])

const saving = ref(false)
const editData = ref({})
const isAutoRenew = ref(false)
const initEndDate = ref(null)
const formData = reactive({
  currentCommissionRate: '',
  startDate: null,
  endDate: null,
  
  brandName: '',
  brandId: '',
  publisherId: '',
 
})



const showModal = async (record) => {

  editData.value = record
  // console.log(editData.value,'editData.value',Array.isArray(editData.value))
  // const brandList = editData.value.brandList
  // // currentTags.value = brandList.map(item=>item.amazonBrandName)
  // const brandNameCount = countBrandNames(brandList,'amazonBrandName')
  // currentTags.value=brandList.map(item=>{
  //   return {
  //     ...item,
  //     hasDuplicate:item.amazonBrandName&&brandNameCount[item.amazonBrandName] > 1
  //   }
  // })


}

// Handle start date change
const handleStartDateChange = (date) => {
  if (date) {
    formData.startDate = moment(date)
    
    // If end date exists and is before start date, clear end date
    if (formData.endDate && moment(formData.endDate).isBefore(moment(date), 'month')) {
      formData.endDate = null
    }
  }
}

// Handle month selection to set it to the last day of the month
const handleEndDateChange = (date) => {
  if (date) {
    const selectedEndDate = moment(date).endOf('month')
    
    // If end date is before start date, clear end date
    if (formData.startDate && selectedEndDate.isBefore(moment(formData.startDate), 'month')) {
      formData.endDate = null
      return
    }
    
    formData.endDate = selectedEndDate
  }
}




const handleClose = () => {

  // Reset form
  formData.currentCommissionRate = ''
  formData.startDate = null
  formData.endDate = null
  saving.value = false

}

const handleAutoRenewChange = (e) => {  

  if(isAutoRenew.value) {
    formData.endDate =  moment('2099-12-31', 'YYYY-MM-DD')
  }else{
    formData.endDate = initEndDate.value
  }
}

const handleRadioClick = (e) => {
  // 如果当前已经是选中状态，则取消选中
  if (isAutoRenew.value) {
    e.preventDefault();
    isAutoRenew.value = false;
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: false } });
  } else {
    // 如果当前未选中，则选中
    e.preventDefault();
    isAutoRenew.value = true;
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: true } });
  }
};

const disabledStartDate = (current) => {
  // Start date should not be before today
  return current && current.isBefore(moment(), 'day')
}

const disabledEndDate = (current) => {
  // End month should not be before start date month and should not be before current month
  return current && ((formData.startDate && current.isBefore(formData.startDate, 'month')) || current.isBefore(moment(), 'month'))
}
const submitData = async() => {
  console.log('submitData')
  saving.value = true
  try {
    const commissionList=editData.value.map(item=>{
        return {
          publisherId: item.id,
          brandId: item.brandId,
          commissionRate: commission.value,
          startDate:formData.startDate.format('YYYY-MM-DD'),
          endDate: formData.endDate.format('YYYY-MM-DD'),
          platformFeeRate:3
        }
      })
      const res=await publishersApi.updatePublisherCommissionBatch({commissionList:commissionList})

      if (res.success) {
      message.success(i18n.global.t('seller.msg.partnershipSaved'))
      emit('refresh')
      handleClose()
    } else {
      message.error(res.error || i18n.global.t('seller.msg.updateFailed'))
    }
  } catch (error) {
    message.error(i18n.global.t('seller.msg.updateFailed'))
    console.error('Update error:', error)
  }finally{
    saving.value = false
  }
 

}
const partneredDataModelRef = ref(null)
// setTimeout(()=>{
//   partneredDataModelRef.value.open([])
// },1000)
const handleConfirm = () => {
  submitData()
}
const handleSave = async () => {
  // Validation
  // if (!formData.currentCommissionRate&&) {
  //   message.error('Please enter commission rate')
  //   return
  // }
  if (commission.value === '' || commission.value === null || commission.value === undefined) {
    message.error(i18n.global.t('seller.brandsPage.errEnterPublisherCommission'))
    return
  }
  if(commission.value==0){
    message.error(i18n.global.t('seller.brandsPage.errPublisherCommissionGt0'))
    return false
  }
  if (!formData.startDate || !formData.endDate) {
    message.error(i18n.global.t('seller.brandsPage.errSelectCollaborationPeriod'))
    return
  }

  // const commissionRate = parseFloat(formData.currentCommissionRate)
  // if (isNaN(commissionRate) || commissionRate < 0 || commissionRate > 100) {
  //   message.error('Commission rate must be between 0 and 100')
  //   return
  // }
  const partneredData=editData.value.filter(item=> item.associateBrandCount)
  
  if(partneredData.length>0){
    partneredDataModelRef.value.open(partneredData)
  }else{
    submitData()
  }
  
  // try {
    // const payload = {
    //   publisherId: editData.value.publisherId,
    //   brandId: editData.value.id,
    //   commissionRate: commission.value,
    //   // platformFeeRate:fees.value,
    //   startDate: formData.startDate.format('YYYY-MM-DD'),
    //   endDate: formData.endDate.format('YYYY-MM-DD')
    // }
    // // console.log(payload,'payload')
    // const res = await publishersApi.updatePublisherCommission(payload)

  //   if (res.success) {
  //     message.success('Updated successfully')
  //     emit('refresh')
  //     handleClose()
  //   } else {
  //     message.error(res.error || i18n.global.t('seller.msg.updateFailed'))
  //   }
  // } catch (error) {
  //   message.error(i18n.global.t('seller.msg.updateFailed'))
  //   console.error('Update error:', error)
  // } finally {
  //   saving.value = false
  // }
}
// 中间输入框逻辑
const commission = ref('')
const showDefalutText = ref(true)
const commissionMinRef = ref(null)
const defaultCommission = ref({
  defaultCommissionRate: 1,
  platformFeeFactor: 1,
  platformMaxFeeRate: 1,
})
function commissionBlur (e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data
}

const handleChangeCommission = (e) => {
  commission.value = e
}

const isCommissionDisabled = computed(() => {
  // if(formData.status === 'inactive') return true
  // 当下个月还在End Date内才可以编辑
  if (!formData.endDate) return false
  
  const nextMonth = moment().add(1, 'month').startOf('month')
  const selectedEndMonth = moment(formData.endDate).startOf('month')
  
  // 如果End Date >= 下个月，则可以编辑（返回true）
  return selectedEndMonth.isSameOrAfter(nextMonth)
})

const fees = computed(() => {
  let value = 0
  if (commission.value) {
    value = (commission.value * defaultCommission.value.platformFeeFactor) / 100
  } else {
    value =
      (defaultCommission.value.defaultCommissionRate *
        defaultCommission.value.platformFeeFactor) /
      100
    if (commission.value == 0) {
      value =
        (commission.value * defaultCommission.value.platformFeeFactor) / 100
    }
  }
  if (value >= defaultCommission.value.platformMaxFeeRate) {
    value = defaultCommission.value.platformMaxFeeRate
  }
  let arr = value && value.toString().split('.')
  let firstNumber = arr && Number(arr[0])
  let middleNum = '0'
  if (arr && arr.length > 1) {
    middleNum = Number(arr[1][0])
    if (arr[1][1] == 5) {
      if (arr[1][0] % 2 !== 0) {
        middleNum += 1
        if (arr[1][0] == 9) {
          middleNum = 0
          firstNumber += 1
        }
      }
    } else if (arr[1][1] > 5) {
      middleNum += 1
      if (arr[1][0] == 9) {
        middleNum = 0
        firstNumber += 1
      }
    }
  }
  let endNum = arr && parseFloat(firstNumber + '.' + middleNum)
  return endNum
})
defineExpose({
  showModal
})
</script>

<style scoped lang="less">
.edit-modal {
  :deep(.ant-radio-wrapper .ant-radio){
    margin-top: -1px;
  }
  :deep(.ant-radio-wrapper .ant-radio-inner){
    border-color: #7653DA;
   
  }
  .container{
    margin-bottom: 40px;
  }
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    .tag-item {
      display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;
      // margin: 4px 8px 4px 0;
      // padding: 4px 8px;
   
      font-size: 13px;

 font-weight: 400;
 line-height: 15px;
 letter-spacing: 0.3px;

     span{
      font-family: "Sora";
 opacity: 0.7;
 color: #0f0629;
     }
    }
    
  
  }
  .brand-section-multi{
    border-radius: 8px;
        background: #50408014;
        flex: 1;
        padding: 12px 12px 12px 0;
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
       
  }
  .brand-section {

    .brand-info {
      margin-bottom: 40px;
      display: flex;
      justify-content: space-around;

      .info-item-content {
        // border-left: 3px solid #7653DA;
        padding-left: 12px;
      }

      .info-item:last-child {
        margin-left: 12px;
      }

      .info-item:first-child {
        margin-right: 12px;
      }

      .info-item {

        // margin-bottom: 8px;
        border-radius: 8px;
        background: #50408014;
        flex: 1;
        padding: 12px 12px 12px 0;

        .label {
          color: #0f0629;
          font-family: "Sora";
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          letter-spacing: 0.3px;
          opacity: 0.7;
        }

        .value {
          color: #0f0629;
          font-family: "Sora";
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 26px;
          letter-spacing: 0.5px;
          opacity: 0.9;
        }
      }
    }


  }

  .title {
    color: #0f0629;
    font-family: "Sora";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;

    letter-spacing: 0.4px;
    opacity: 0.9;
  }

  .commission-section {
    margin-bottom: 40px;
  }

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    // margin-bottom: 20px;

    .commission {
      display: flex;

      >span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        >span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        >button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          >span {
            align-self: center;
          }
        }
      }

      .fees {
        >button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        >button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }
  }

  .current-commission {
    display: flex;
    align-items: center;

    margin-bottom: 40px;
   
    >button {
      margin-left: 16px;
      padding-left: 12px;
      text-align: left;
      border-radius: 8px;
      font-weight: 500;
      font-size: var(--font-size-large);
      color: var(--dark-1) !important;
      min-width: 62px !important;
      max-width: 62px !important;
      padding: 0 !important;
      text-align: center !important;
    }
  }
  :deep(.artmisads-button.artmisads-default:disabled){
    background: #EEEDF2 !important;
    border: 1px solid #CCC7D9 !important;
  }


  .collaboration-section {
    margin-bottom: 26px;

    .section-title {
      color: #0f0629;
      font-family: "Sora";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      letter-spacing: 0.4px;
      opacity: 0.9;
      margin-bottom: 8px;
    }

    .date-row {
      display: flex;
      gap: 24px;

      .date-group {
        flex: 1;

        .date-label {
          font-size: 14px;
          color: rgba(15, 6, 41, 0.8);
          margin-bottom: 8px;
          font-weight: 500;
        }

        .date-picker {
          width: 100%;
        }
      }
    }
  }
  .auto-renew-section {
    margin-bottom: 26px;
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    .cancel-button{
      min-width: 96px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
 font-weight: 500;

 letter-spacing: 0.4px;
 opacity: 0.7;
    }
    .artmisads-button {
      min-width: 96px;
      font-family: "Sora";
      font-weight: 500;
    }
  }
}
</style>